import React from "react";
import CreateProspectContent from "../components/prospects/create-prospect-content";

const CreateProspect = () => {
  return <CreateProspectContent />;
};

export default CreateProspect;
